import { Calendar } from '@/components/ui/calendar';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card';

interface CalendarPopoverContentProps {
  selected: Date | undefined;
  onSelect: (date?: Date) => void;
  quickOptions: Array<{ label: string; getDate: () => Date }>;
  onQuickSelect: (getDate: () => Date) => void;
  onClear: () => void;
  onClose: () => void;
}

export function CalendarPopoverContent({
  selected,
  onSelect,
  quickOptions,
  onQuickSelect,
  onClear,
}: CalendarPopoverContentProps) {
  return (
    <Card className="max-w-[300px] py-4">
      <CardContent className="px-4">
      <Calendar
        mode="single"
        selected={selected}
        onSelect={onSelect}
        defaultMonth={selected}
        timeZone="America/Detroit"
          classNames={{
            root: "bg-transparent p-0",
            today: "bg-secondary/60 rounded-md",
            outside: "text-muted-foreground opacity-50"
          }}
        />
      </CardContent>  
      <CardFooter className="flex flex-col gap-2 border-t px-4 !pt-4">
        {quickOptions.length > 0 && (
          <div className="w-full flex flex-wrap gap-2 mb-1">
            {quickOptions.map((option) => (
              <Button
                key={option.label}
                variant="outline"
                size="sm"
                className="flex-1 px-2"
                onClick={() => onQuickSelect(option.getDate)}
              >
                {option.label}
              </Button>
            ))}
          </div>
        )}
        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={onClear}
        >
          Clear
        </Button>
      </CardFooter>
      </Card>
  );
}
